import { useState } from 'react';

import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import {
  Alert,
  AlertTitle,
  Box,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import EnergyAnalyzerFilterInput from '../../../components/forms/energyxplorer/EnergyAnalyzerFilterInput';
import HourAnalysisChart from '../../../components/highcharts/powerAnalyser/HourAnalysisChart';
import InfoTooltipIcon from '@/components/icons/InfoTooltipIcon';

const HourAnalysisDialog = ({
  data = [],
  isLoading = true,
  setFilterOptions,
}) => {
  const handleApplyFilters = async (filters) => {
    setFilterOptions(filters);
  };

  const [viewMode, setViewMode] = useState('column');

  return (
    <>
      <Box display={'flex'} flexDirection={'column'}>
        <Box display={'flex'} gap={2} sx={{ mt: 2 }}>
          <Grid container columns={12}>
            <Grid item md={8}>
              {data ? (
                <HourAnalysisChart
                  data={data}
                  viewMode={viewMode}
                  isLoading={isLoading}
                />
              ) : (
                <Alert severity="error" sx={{ mt: 2 }}>
                  <AlertTitle>Ingen data tilgængelig</AlertTitle>
                  Det er ikke muligt at vise døgnforbrugsanalyse.
                </Alert>
              )}
            </Grid>

            <Grid item md={4}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  variant="body1"
                  color="textSecondary"
                  fontWeight="bold"
                >
                  Visning
                </Typography>
                <InfoTooltipIcon title="Anvend filtrering på data for et bedre indblik." />
              </Box>
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                sx={{ my: 2 }}
              >
                <Tooltip title="Gennemsnitsvisning i kolonner." placement="top">
                  <IconButton
                    onClick={() => setViewMode('column')}
                    sx={{
                      borderRadius: 3,
                      mr: 1,
                    }}
                  >
                    <BarChartRoundedIcon />
                  </IconButton>
                </Tooltip>

                <Tooltip
                  title="Vis som boksplot for at se variationen i timeforbruget."
                  placement="top"
                >
                  <IconButton
                    onClick={() => setViewMode('box')}
                    sx={{
                      borderRadius: 3,
                    }}
                  >
                    <TuneRoundedIcon sx={{ transform: 'rotate(90deg)' }} />
                  </IconButton>
                </Tooltip>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  variant="body1"
                  color="textSecondary"
                  fontWeight="bold"
                >
                  Filtrering
                </Typography>
                <InfoTooltipIcon title="Anvend filtrering på data for et bedre indblik." />
              </Box>
              <EnergyAnalyzerFilterInput
                handleApply={handleApplyFilters}
                setComparisonFilters={setFilterOptions}
                context="hourAnalysis"
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default HourAnalysisDialog;
